import React from "react";
import { useDispatch } from "react-redux";

import { AppDispatch } from "store";
import { setTradeButtonHover } from "store/slices/tradingSlice";
import styles from "./TradingPanel.module.css";

interface Props {
  selectedPair: string | null;
  amount: number;
  duration: number;
  placeOrder: (
    pair: string | null,
    direction: "buy" | "sell",
    amount: number,
    duration: number,
  ) => void;
  isOrderButtonDisabled: boolean;
  orderInProgress: "buy" | "sell" | null;
}

export const TradeButtons: React.FC<Props> = ({
  selectedPair,
  amount,
  duration,
  placeOrder,
  isOrderButtonDisabled,
  orderInProgress,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div className={`${styles.item} ${styles.tradeButtons}`}>
      <button
        className={`${styles.tradeButton} ${styles.tradeButtonBuy}`}
        onClick={() => placeOrder(selectedPair, "buy", amount, duration)}
        onMouseEnter={() => dispatch(setTradeButtonHover("buy"))}
        onMouseLeave={() => dispatch(setTradeButtonHover(null))}
        disabled={isOrderButtonDisabled}
      >
        {orderInProgress === "buy" ? "⏳" : "BUY"}
      </button>
      <button
        className={`${styles.tradeButton} ${styles.tradeButtonSell}`}
        onClick={() => placeOrder(selectedPair, "sell", amount, duration)}
        onMouseEnter={() => dispatch(setTradeButtonHover("sell"))}
        onMouseLeave={() => dispatch(setTradeButtonHover(null))}
        disabled={isOrderButtonDisabled}
      >
        {orderInProgress === "sell" ? "⏳" : "SELL"}
      </button>
    </div>
  );
};
